export const formWatching = (self, {getWatcher}) => {
    if (!getWatcher)
        getWatcher = () => ({});

    const watcher = getWatcher();
    const defaultWatch = () => {};

    //console.log(watcher);

    const watch = (key, isFirstRun = false) => {
        //console.log(watcher[key]);
        (watcher[key] || defaultWatch)(self.getValue(key), self, isFirstRun)
    };

    Object.entries(watcher).forEach(([key]) => watch(key, true));

    return {
        watch,
    };
};